export default __webpack_public_path__ + "static/media/42_mobile.54b068b1.jpg";